import React, { useState, useEffect } from 'react';
import { Typography, Box, makeStyles } from '@material-ui/core';
import { withNamespaces, Trans } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import Vintage from '../../../../../components/images/vintage13.png';

import { StraightStripes } from '../../../../../components/icons';

const useStyles = makeStyles((theme) => ({
	imageContainer: {
		position: 'absolute',
		background: `transparent url(${Vintage}) 0% 0% no-repeat padding-box`,
		mixBlendMode: 'multiply',
		width: '100%',
		height: '100%',
		backgroundSize: 'cover',
	},
	imageContainerFixed: {
		position: 'absolute',
		backgroundColor: '#DDE9E6',
		width: 639,
		height: 481,
		top: 126,
		left: 0,
		[theme.breakpoints.only('xs')]: {
			width: '100%',
			top: 0,
			left: 0,
			height: 300,
		},
		[theme.breakpoints.only('md')]: {
			width: 500,
			height: 400,
			top: 300,
		},
		[theme.breakpoints.only('sm')]: {
			width: 590,
			top: -20,
			right: 0,
			left: 'auto',
			height: 450,
		},
	},
	pageContainer: {
		position: 'fixed',
		[theme.breakpoints.down('md')]: {
			position: 'absolute',
			width: '100%',
		},
		width: 1215,
		marginLeft: 'auto',
		marginRight: 'auto',
		right: 0,
		left: 0,
		top: 129,
		[theme.breakpoints.only('xs')]: {
			top: 0,
		},
		[theme.breakpoints.only('xl')]: {
			top: 200,
		},
	},
	mainTitleBox: {
		top: 52,
		position: 'absolute',
		background: theme.palette.primary.dark,
		left: 63,
		textAlign: 'left',
		zIndex: 101,
		[theme.breakpoints.only('xs')]: {
			top: 230,
		},
		[theme.breakpoints.only('md')]: {
			top: 150,
		},
		[theme.breakpoints.only('sm')]: {
			top: 150,
		},
	},
	mainTitleText: {
		fontFamily: 'Bebas Neue',
		color: '#E0B080',
		fontSize: '30px',
		letterSpacing: '0.30px',
		lineHeight: '30px',
		marginTop: 12,
		marginRight: 86,
		marginBottom: 12,
		marginLeft: 86,
		[theme.breakpoints.only('xs')]: {
			marginTop: 7,
			marginRight: 20,
			marginBottom: 3,
			marginLeft: 20,
			fontSize: 30,
			lineHeight: '30px',
			letterSpacing: '2px',
		},
	},
	halfStripes: {
		top: 0,
		left: 71,
		position: 'absolute',
		zIndex: 100,
		width: '400px',
		height: '252px',
		[theme.breakpoints.only('xs')]: {
			width: 300,
			left: 0,
			opacity: 0.5,
		},
		[theme.breakpoints.only('md')]: {
			top: 50,
		},
		[theme.breakpoints.only('sm')]: {
			top: 50,
		},
	},
	descriptionContainer: {
		position: 'absolute',
		top: 58,
		width: 552,
		right: 0,
		[theme.breakpoints.only('md')]: {
			width: 500,
		},
		[theme.breakpoints.only('xs')]: {
			width: '100%',
			top: 300,
		},
		[theme.breakpoints.only('sm')]: {
			width: '100%',
			top: 400,
		},
	},
	descriptionText: {
		textAlign: 'left',
		letterSpacing: '0.18px',
		fontSize: '18px',
		lineHeight: '30px',
		flexWrap: 'wrap',
		fontWeight: 'bold',
		[theme.breakpoints.only('md')]: {
			marginRight: 50,
		},
		[theme.breakpoints.only('xs')]: {
			marginLeft: 20,
			marginRight: 20,
			fontSize: '16px',
		},
		[theme.breakpoints.only('sm')]: {
			marginLeft: 20,
			marginRight: 20,
		},
	},
}));

function MadefalvaHistory6(props) {
	const classes = useStyles();
	const { t } = props;
	const [showAnimation, setShowAnimation] = useState(props.showAnimation);
	useEffect(() => {
		if (props.showAnimation) {
			const timeOut = setTimeout(() => {
				setShowAnimation(props.showAnimation);
			}, 300);
			return () => clearTimeout(timeOut);
		}
		setShowAnimation(props.showAnimation);
	}, [props.showAnimation]);

	return (
		<Box className={classes.pageContainer}>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='bttmiddle'
				unmountOnExit>
				<Box className={classes.imageContainerFixed}>
					<Box className={classes.imageContainer} />
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='ltrlong'
				unmountOnExit>
				<Box className={classes.mainTitleBox}>
					<Typography className={classes.mainTitleText}>
						{t('madehistory6.maintitle')}
					</Typography>
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='ttbmiddle'
				unmountOnExit>
				<Box className={classes.descriptionContainer}>
					<Typography className={classes.descriptionText}>
						<Trans i18nKey='madehistory6.description' />
					</Typography>
				</Box>
			</CSSTransition>
			<CSSTransition
				in={showAnimation}
				timeout={300}
				classNames='ltrlong'
				unmountOnExit>
				<Box className={classes.halfStripes}>
					<StraightStripes width='100%' height='100%' />
				</Box>
			</CSSTransition>
		</Box>
	);
}

export default withNamespaces('madefalvaHistory')(MadefalvaHistory6);
